import NewsNav from '@/components/NewsNav';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import seoconfig from '@/seoconfig/news';
import { fetchWP2, isReadyLang, redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { Skeleton, Typography } from 'antd';
import moment from 'moment';
import Head from 'next/head';
import { FacebookShareButton, InstapaperShareButton, TwitterShareButton } from 'react-share';
import sanitizeHtml from 'sanitize-html';
import css from './newsDetail.module.scss';
const isBuild = process.env.NEXT_MODE === 'build';
const { Paragraph } = Typography;

export default function Details({ postsData, detailsData, categoriesData, SEO }: any) {
    const { useState, useRouter, Link, useLang, useEffect, gtm } = useGlobal();
    let otherData = [];
    const [url, setUrl] = useState('');
    const { t } = useLang('shared');

    const onShareClick = (type: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'share',
            method: type,
            item_id: sanitizeHtml(detailsData?.title?.rendered, {
                allowedTags: [''],
            }),
        });
    };

    const getDataLayer = (params: any) => {
        const { title, type } = params;
        return {
            event: 'uaEvent',
            event_name: 'select_news',
            title_name: title,
            button_name: type,
        };
    };

    const categoryMap = {} as any;
    categoriesData?.map((item: any) => {
        categoryMap[item.id] = item.name;
    });

    const getCategoryName = (data: any) => {
        if (!data || !Array.isArray(data.categories)) return '';
        const detailCategory = [...data.categories]?.pop();
        return categoryMap[String(detailCategory)]?.toUpperCase();
    };
    const categoryName = getCategoryName(detailsData);
    const router = useRouter();
    const { locale } = router;

    const viewMore = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'view_more',
            list_name: 'Other articles',
            button_name: 'view_more',
        });
        router.push(`/${locale}/news`);
    };

    const others: any = [];
    if (Array.isArray(postsData)) {
        postsData?.map((item: any) => {
            const images = item.yoast_head_json?.og_image || [
                {
                    url: '/img/blank-image.png',
                    width: '360',
                    height: '260',
                },
            ];
            if (item.id != detailsData?.id) {
                others.push({
                    id: item.id,
                    title: item.title.rendered,
                    content: item.content.rendered,
                    images: item.jetpack_featured_media_url || images[0].url,
                    width: images[0].width,
                    height: images[0].height,
                    category: getCategoryName(item),
                    slug: item.slug,
                });
            }
        });
    }

    otherData = others.slice(0, 3);

    useEffect(() => {
        setUrl(window.location.href);
    }, []);

    return (
        <PageLayout className={css.detailWrapper} style={{ background: '#fff' }}>
            <SEO
                title={sanitizeHtml(detailsData?.title?.rendered, {
                    allowedTags: [''],
                })}
                description={sanitizeHtml(detailsData?.excerpt?.rendered?.replace(/(\[|\])/g, ''), {
                    allowedTags: [''],
                })}
            />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            {detailsData?.title?.rendered === 'Wichtiges Firmware-Upgrade für DELTA 2 Powerstation' && (
                <Head>
                    <meta name="robots" content="noindex, nofollow" key="robots" />
                    <meta name="googlebot" content="noindex, nofollow" key="googlebot" />
                </Head>
            )}
            <NewsNav className="wbg" title={t('news.title_nav')} category="newsroom" />
            <div className="container">
                <div className="details-box">
                    {router.isFallback && <Skeleton active />}
                    {!router.isFallback && (
                        <>
                            <div className="details">
                                {categoryName && <span className="label">{categoryName}</span>}
                                <h1 className="h1">
                                    {sanitizeHtml(detailsData?.title?.rendered, {
                                        allowedTags: [''],
                                    })}
                                </h1>
                                <div className="sub font-family-medium">
                                    <span className="author">
                                        <i>{t('news.by')}</i> {t('news.EcoFlow')}
                                    </span>
                                    <span className="date">{moment(detailsData?.date).format('YYYY-MM-DD')}</span>
                                </div>
                                {/* <div
                                        className="des font-family-medium"
                                        dangerouslySetInnerHTML={{
                                            __html: detailsData?.excerpt?.rendered?.replace(/(\[|\])/g, ''),
                                        }}
                                    ></div> */}

                                <div className="share">
                                    <FacebookShareButton url={url} onClick={() => onShareClick('Facebook')}>
                                        <div className="fbImg"></div>
                                    </FacebookShareButton>
                                    <TwitterShareButton url={url} onClick={() => onShareClick('Twitter')}>
                                        <div className="twImg">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="#666666" width="24px" height="24px">
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM12.2164 15.2598L6.03901 7H10.8001L14.8499 12.415L19.8621 7H21.2612L15.475 13.251L22 21.9754H17.2389L12.8415 16.0958L7.39907 21.9754H6L12.2164 15.2598ZM10.2837 8.03056H8.09645L17.755 20.9447H19.9422L10.2837 8.03056Z"
                                                    fill="#9c9c9c"
                                                />
                                            </svg>
                                        </div>
                                    </TwitterShareButton>
                                    <InstapaperShareButton url={url} onClick={() => onShareClick('Instagram')}>
                                        <div className="insImg"></div>
                                    </InstapaperShareButton>
                                </div>

                                {['au', 'uk', 'de', 'fr', 'es', 'jp', 'ca'].includes(locale) && (
                                    <div className="content topImage" style={{ position: 'relative', height: 500 }}>
                                        <Image
                                            src={detailsData?.jetpack_featured_media_url}
                                            layout="fill"
                                            className="fullImgs"
                                            alt={sanitizeHtml(detailsData?.title?.rendered, {
                                                allowedTags: [''],
                                            })}
                                        />
                                    </div>
                                )}

                                <div
                                    className="content"
                                    dangerouslySetInnerHTML={{
                                        __html: detailsData?.content?.rendered,
                                    }}
                                ></div>
                            </div>

                            <div className="others-box">
                                <h2 className="title">
                                    {t('news.other_articles')}{' '}
                                    <span className="view-more" onClick={viewMore}>
                                        {t('news.view_more')}{' '}
                                        <span className="imgs" style={{ marginLeft: '11px' }}>
                                            <EFArrowDown
                                                style={{
                                                    fontSize: '12px',
                                                    transform: 'rotate(-90deg)',
                                                }}
                                            />
                                        </span>
                                    </span>
                                </h2>
                                <ul>
                                    {otherData?.map((item: any) => (
                                        <li className="items" key={item.id + Math.random()}>
                                            <div className="item-t">
                                                {item.images && (
                                                    <Link
                                                        href={`/news/${item.id}/${item.slug}`}
                                                        ariaLabel={item.title}
                                                        dataLayer={getDataLayer({
                                                            title: item.title,
                                                            type: 'Image',
                                                        })}
                                                    >
                                                        <Image src={item.images} layout="fill" className="fullImgs" alt={item.title} />
                                                    </Link>
                                                )}
                                                {item.category && <span className="label">{item.category}</span>}
                                            </div>
                                            <h4>
                                                <Link
                                                    href={`/news/${item.id}/${item.slug}`}
                                                    ariaLabel={item.title}
                                                    dataLayer={getDataLayer({
                                                        title: item.title,
                                                        type: 'Title',
                                                    })}
                                                >
                                                    <Paragraph ellipsis={{ rows: 2 }}>{item.title}</Paragraph>
                                                </Link>
                                            </h4>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </PageLayout>
    );
}
const newsroomObj: any = {
    en: 'categories&slug=newsroom',
    it: 'categories&slug=news-room',
};

const NEXT_PUBLIC_MODY = process.env.NEXT_PUBLIC_MODY;
const IS_LOCAL_TEST = NEXT_PUBLIC_MODY === 'test' || NEXT_PUBLIC_MODY === 'uat';
export async function getServerSideProps({ params, locale }: any) {
    if (!isReadyLang(locale) || locale === 'sa') {
        return redirectTo404();
    }
    const id = params.id[0];
    let detailsData = null;
    let categoriesData = [];
    let newsInCategories = [];
    let newsroom = [];
    let newsroomCategories: any = [];
    const newsroomUrl = newsroomObj[locale] || newsroomObj['en'];
    if (!IS_LOCAL_TEST) {
        try {
            detailsData = await fetchWP2(`posts/${id}`, locale);
            newsInCategories = detailsData?.categories || [];
            categoriesData = await fetchWP2('categories', locale);

            // 如果不明文传参slug=newsroom，可能找不到新闻目录
            newsroom = await fetchWP2(newsroomUrl, locale);
        } catch (e) {
            // console.log('fetch-error1: path [news]', e);
        }
    }

    const newsroomId = newsroom[0]?.id;

    // 如果不是 newsroom 下的博客文章，转到 404
    if (newsroomId && !newsInCategories?.includes(newsroomId)) {
        return redirectTo404();
    }

    if (newsroomId) {
        newsroomCategories = categoriesData?.filter((item: any) => item.parent === newsroomId)?.map((item: any) => item.id);
        newsroomCategories.push(newsroomId);
    }

    let postsData = [];

    if (!IS_LOCAL_TEST) {
        try {
            if (isBuild) {
                const allPosts = await require(`/scripts/cache/news/posts/${locale}.json`);
                postsData = allPosts?.filter((post: any) => {
                    return post.id !== Number(id) && post.categories?.find((category: any) => newsroomCategories?.includes(category));
                });
                if (postsData?.length > 3) {
                    postsData = postsData?.slice(0, 3);
                }
            } else {
                postsData = await fetchWP2(`posts&per_page=3&categories=${newsroomCategories.join(',')}&exclude=${id}`, locale);
            }
        } catch (e) {
            // console.log('fetch-error2: path [news]', e);
        }
    }

    return {
        props: {
            postsData: postsData || null,
            detailsData: detailsData || null,
            categoriesData: categoriesData || null,
        },
    };
}
